<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">工程建设</div>
                     <div class="title-e">ENGINEERING CONSTRUC</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe">
                 建设中心生成建设方案及物资采购方案，对在建工程进行施工过程管控，结算中心完成相关财务结算。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon21"></span> 定制化建设工程方案
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon22"></span> 生成设备采购清单
                 </div>
             </div>

             <div class="data-describe">
                 <div class="data-box data04">
                     <div class="data-num">2<span class="min-span">天</span></div>
                     <div class="data-synopsis">
                         <p>选定土地后动工建设</p>
                         <p>最短2天</p>
                     </div>
                 </div>
                 <div class="data-line"></div>
                 <div class="data-box data-t">
                     <div class="data-num"><span></span>60<span  class="min-span">天</span></div>
                     <div class="data-synopsis">
                         <p>完成工程验收通电</p>
                         <p>60天内</p>
                     </div>
                 </div>
             </div>
             <div class="img-describe img2"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./i_public.less" lang="less" scoped></style>
<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fff;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 1200px;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            <!--.describe-characteristic{-->
                <!--width: 1000px;-->
                <!--margin: 10px auto;-->
                <!--text-align: left;-->
                <!--color: #1A3068;-->
                <!--font-size: 14px;-->
                <!--line-height: 28px;-->
                <!--.icon-img{-->
                    <!--display: inline-block;-->
                    <!--width: 24px;-->
                    <!--height:24px;-->
                    <!--margin-right: 6px;-->
                    <!--background-repeat: no-repeat;-->
                    <!--background-size: 24px 24px;-->
                    <!--margin-bottom: -6px;-->
                <!--}-->
                <!--.icon1{-->
                    <!--background-image: url('./../../../assets/icon_chongdian2_a@2x.png');-->
                <!--}-->
                <!--.icon2{-->
                    <!--background-image: url('./../../../assets/icon_chongdian2_b@2x.png');-->
                <!--}-->
            <!--}-->
            <!--.data-describe{-->
                <!--width: 1000px;-->
                <!--margin: 20px auto;-->
                <!--display: flex;-->
                <!--.data-box{-->
                    <!--width: 170px;-->
                    <!--height:120px;-->
                    <!--padding:10px;-->
                    <!--.data-num{-->
                        <!--color: #19C1E7;-->
                        <!--font-size: 32px;-->
                    <!--}-->
                    <!--.data-synopsis{-->
                        <!--font-size: 14px;-->
                        <!--line-height: 10px;-->
                        <!--font-family:PingFangSC-Regular,PingFang SC;-->
                        <!--font-weight:400;-->
                        <!--color:rgba(26,48,104,1);-->
                    <!--}-->
                <!--}-->
                <!--.data-line{-->
                    <!--min-width: 1px;-->
                    <!--height: 50px;-->
                    <!--background-color: #E6E9F3;-->
                    <!--margin-top: 20px;-->
                <!--}-->

            <!--}-->
            <!--.img-describe{-->
                <!--height: 360px;-->
                <!--width: 376px;-->
                <!--background-image: url('./../../../assets/gcjianshe.gif');-->
                <!--background-repeat: no-repeat;-->
                <!--background-size: 80%;-->
                <!--position: absolute;-->
                <!--bottom: 80px;-->
                <!--right: 60px;-->
            <!--}-->
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 1100px) {-->
        <!--.img-describe{-->
            <!--background-size: 60%!important;-->
            <!--right: -40px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 1000px) {-->
        <!--.img-describe{-->
            <!--background-size:45%!important;-->
            <!--height: 260px;-->
            <!--width: 264px;-->
            <!--background-image: url(/img/yunwei.gif);-->
            <!--background-repeat: no-repeat;-->
            <!--position: absolute;-->
            <!--bottom: 70px!important;-->
            <!--right:-100px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 800px) {-->
        <!--.img-describe{-->
            <!--display: none;-->
        <!--}-->
    <!--}-->








<!--</style>-->